/* eslint-disable no-console */
const deprecate = (message) => console.warn(`Deprecated: ${message}`);

export { deprecate };
